import React, { useEffect } from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import "./DialogTransferOrder.scss";
import Translated from "../../../components/Translated/Translated";

function DialogTransferOrder(props) {
	const [open, setOpen] = React.useState(false);
	const [noticeOpen, setNoticeOpen] = React.useState(false);
	const [resultOpen, setResultOpen] = React.useState(false);
	const [quote, setQuote] = React.useState({});
	const [send_room_titles, set_send_room_titles] = React.useState({});
	const [response, setResponse] = React.useState({});
	const [transferType, setTransferType] = React.useState("");
	const [submit_disable, set_submit_disable] = React.useState(false);
	const [updatedProducts, setUpdatedProducts] = React.useState([]);
	// Set to true if users belong to 202 or 282, allowing them to send C25 orders
	const [useAllOrderTypes, setUseAllOrderTypes] = React.useState(false);

	useEffect(() => {
		async function checkUserWarehouses() {
			try {
				const instance = Axios.create({
					headers: { Authorization: "Bearer " + localStorage.getItem("token") }
				});
				let ajaxURL = props.APIUrl + "/consultant/consultant-profile";
				let APIResponse = await instance.get(ajaxURL);

				let consultantWarehouses = APIResponse.data.consultantWarehouses;

				for(let i = 0; i < consultantWarehouses.length; i++) {
					if(consultantWarehouses[i].warehouse === '202' || consultantWarehouses[i].warehouse === '282') {
						setUseAllOrderTypes(true);
						break;
					}
				}
				return;
			} catch (error) {
				console.log("here is the error message ", error.message);
			}
		}
		checkUserWarehouses();
	}, []);

	async function handleClose() {
		setOpen(false);
	}

	async function handleNoticeClose() {
		setNoticeOpen(false);
		handleClickOpen();
	}

	async function handleResultClose() {
		setResultOpen(false);
		handleClickOpen();
	}

	async function handleNoticeOpen(inputTransferType) {
		setTransferType(inputTransferType);

		if(props.notInWarehouseProduct) {
			setNoticeOpen(true);
		} else {
			handleClickOpen();
		}
	}

	async function handleClickOpen() {
		setResponse({});
		set_submit_disable(false);
		let ajaxURL = props.APIUrl + "/emco_quotes/application-settings";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		if (APIResponse.data.hasOwnProperty("error")) {
			setResponse(APIResponse.data);
		} else {
			setQuote(APIResponse.data.quote);
			// 20210108
			// SO api expects send_room titles to be 2 if they are to be sent
			// But we only send 0 or 1 since backend increments, so 0 to 1 & 1 to 2
			// We gotta filter user setting's send_room_titles 2 to 1 & 1 to 0
			// Becuase user settings are weird, 0 is ask, 1 is not send & 2 is send
			// 2 from user settings to 1
			if(APIResponse.data.send_room_titles > 1) {
				set_send_room_titles(1);
			} 
			// 1 from user settings to 0
			else if(APIResponse.data.send_room_titles === 1) {
				set_send_room_titles(0);
			} 
			// 0 from user settings as normal
			else {
				set_send_room_titles(APIResponse.data.send_room_titles);
			}
		}
		setOpen(true);
	}

	async function checkNotInWarehouse() {
		set_submit_disable(true);

		let ajaxURL = props.APIUrl + "/products/check-catalog-products";
		let data = { projectId: props.projectId };
		let catalogProductCheck = await Axios.post(ajaxURL, data);

		setUpdatedProducts(catalogProductCheck.data.updatedProducts);
		setNoticeOpen(false);
		setResultOpen(true);
		props.toggleNotInWarehouseStatus(catalogProductCheck.data.updatedProducts);
		set_submit_disable(false);
	}

	async function submit() {
		set_submit_disable(true);
		let ajaxURL = props.APIUrl + "/emco_quotes/send-order";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId,
			quote: quote,
			order_type: transferType,
			send_room_titles: send_room_titles
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		setResponse(APIResponse.data);
		if(APIResponse.data.hasOwnProperty("success")) {
			props.successCall();
		}
		return;
	}

	function formBody() {
		return (
			<div class="quote-dialog-body transfer-order">
				<div class="transfer-order-message"><Translated section="Misc" label="send_room_titles_to_trend_label" /></div>
				<div class="transfer-order-radio-wrapper">
					<div class="transfer-order-choice">
						<input
							type="radio"
							id="no-send-room-titles"
							name="radio-send-room-titles"
							defaultChecked={!send_room_titles}
							onChange={() => {
								set_send_room_titles(0);
							}}
						/>
						<label for="no-send-room-titles"><Translated section="Misc" label="no_btn" /></label>
					</div>
					<div class="transfer-order-choice">
						<input
							type="radio"
							id="yes-send-room-titles"
							name="radio-send-room-titles"
							defaultChecked={send_room_titles}
							onChange={() => {
								set_send_room_titles(1);
							}}
						/>
						<label for="yes-send-room-titles"><Translated section="Misc" label="yes_btn" /></label>
					</div>
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="quote-nav-component">
			<input type="radio" name="quote-nav-radio" id="transfer-order-toggle" />
			<label class="quote-nav-top-link" for="transfer-order-toggle">
				<div class="quote-dialog-arrow">&#9664;</div>
				<div><Translated section="Quote" label="sub_nav_transfer" /></div>
			</label>

			<div class="quote-nav-sidedrop">
				<button
					onClick={e => {
						handleNoticeOpen("C56");
					}}
					class="quote-nav-sub-link"
				>
					C56
				</button>
				<button
					onClick={e => {
						handleNoticeOpen("Q02");
					}}
					class="quote-nav-sub-link"
				>
					Q02
				</button>
				{!!useAllOrderTypes && (
					<button
						onClick={e => {
							handleNoticeOpen("C25");
						}}
						class="quote-nav-sub-link"
					>
						C25
					</button>
				)}
			</div>
			<Dialog open={open} onClose={handleClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="order_push_dialog_title" /></div>

					{hasResponse ? responseBody() : formBody()}

					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}>
							{hasResponse 
								? <Translated section="Misc" label="close_btn" />
								: <Translated section="Misc" label="cancel_btn" />
							}
						</button>
						{hasResponse ? (
							""
						) : (
							<button class="quote-dialog-button" disabled={submit_disable} onClick={submit}>
								{submit_disable
									? <i class="fa fa-spinner fa-spin"></i>
									: <Translated section="Misc" label="ok_btn" />
								}
							</button>
						)}
					</div>
				</div>
			</Dialog>

			<Dialog open={noticeOpen} onClose={handleNoticeClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="order_push_dialog_title" /></div>

					<div class="transfer-order-notice">
						<Translated section="Misc" label="not_in_warehouse_item_notice" />
					</div>
					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleNoticeClose}>
							<Translated section="Misc" label="continue_btn" />
						</button>
						<button class="quote-dialog-button" disabled={submit_disable} onClick={checkNotInWarehouse}>
								{submit_disable
									? <i class="fa fa-spinner fa-spin"></i>
									: <Translated section="Quote" label="update_btn" />
								}
						</button>
					</div>
				</div>
			</Dialog>

			<Dialog open={resultOpen} onClose={handleResultClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="order_push_dialog_title" /></div>

					<div class="transfer-order-notice">
					{(updatedProducts && updatedProducts.length) ?
						updatedProducts.map((updatedProduct, index) => (
							<React.Fragment key={index}>
								<b>{updatedProduct.vendorProd}</b>
								<p>
									<Translated section="Misc" label="old_price_label" />{" "}: {updatedProduct.oldPrice}
									<br />
									<Translated section="Misc" label="new_price_label" />: {updatedProduct.newPrice}
								</p>
							</React.Fragment>
						)
						) : 'No products were updated'}
					</div>
					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleResultClose}>
							<Translated section="Misc" label="continue_btn" />
						</button>
					</div>
				</div>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialogTransferOrder);
